import React from "react"
import { Box, Typography } from "@mui/material"

import { AppOfficesBlock } from "@components"


export const hasExecutionInfo = (officeData, executionDateTime) => !!officeData?.name || !!executionDateTime

// "Office - date" of the execution next to a chart title. Only what arrived is shown: no office and no
// date means nothing at all, and the dash only sits between the two.
export default function AnalyzerExecutionInfo({ officeData, executionDateTime, fontSize }) {
	const hasOffice = !!officeData?.name
	if (!hasExecutionInfo(officeData, executionDateTime)) return null

	return <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
		{hasOffice && <AppOfficesBlock {...officeData} sx={fontSize ? { fontSize } : undefined}/>}
		{hasOffice && !!executionDateTime && '-'}
		{!!executionDateTime && <Typography variant="subtitle2" fontWeight="regular" sx={fontSize ? { fontSize } : undefined}>
			{executionDateTime}
		</Typography>}
	</Box>
}
